<label class="upload-container"
       *ngIf="!photoLoading"
       title="{{'Add photo' | translate}}">

  <i class="material-icons upload-container__icon">
    add_a_photo
  </i>

  <input
    type="file"
    accept="image/*"
    (change)="onSelectPhoto($event)"
    style="display: none;">
</label>

<mat-spinner diameter="24" *ngIf="photoLoading"></mat-spinner>
